var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff9494",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.457,215.191C495.734,105.38,409.237,16.616,296.779,0.515c-27.601-3.947-53.284,15.228-57.227,42.843l-18.45,129.146 C213.158,180.447,33.7,359.905,24.504,369.102c-32.634,32.633-32.634,85.732,0,118.365c32.709,32.71,85.652,32.714,118.365,0 c9.198-9.198,188.657-188.656,196.599-196.598l129.146-18.45C496.209,268.477,515.411,242.805,511.457,215.191z M119.196,463.794 c-9.486,9.486-22.096,14.708-35.51,14.708c-13.414,0-26.024-5.224-35.51-14.708c-19.579-19.581-19.579-51.439,0-71.019 l106.528-106.528l71.019,71.02L119.196,463.794z M249.398,333.592l-71.018-71.02l58.505-58.505l71.019,71.02L249.398,333.592z M463.879,239.277l-126.384,18.055l-82.856-82.856l18.056-126.383c1.337-9.361,10.138-15.755,19.34-14.437 c8.904,1.274,17.641,3.093,26.178,5.417l-13.429,43.855c-2.707,8.84,2.264,18.2,11.105,20.907 c8.845,2.707,18.201-2.27,20.906-11.105l12.977-42.38c19.65,8.774,37.806,20.355,53.944,34.232l-34.947,34.948 c-6.537,6.537-6.537,17.136,0,23.673c6.536,6.537,17.136,6.538,23.673,0l34.948-34.948c13.933,16.204,25.552,34.442,34.338,54.182 l-42.376,12.884c-8.845,2.689-13.835,12.04-11.146,20.885c2.688,8.843,12.037,13.836,20.885,11.146l43.875-13.339 c2.29,8.456,4.088,17.108,5.35,25.924C479.646,229.229,473.152,237.953,463.879,239.277z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeup);
export default __webpack_public_path__ + "static/media/makeup.05b74e9dec253bf0594e932601836dcc.svg";
export { ForwardRef as ReactComponent };